import { render, staticRenderFns } from "./LessonAbsences.vue?vue&type=template&id=cc44f5f6"
import script from "./LessonAbsences.vue?vue&type=script&lang=js"
export * from "./LessonAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports